import { AsyncPipe, NgClass } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { NgSelectModule } from '@ng-select/ng-select';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { I18nModule, provideConfig, StateTransferType } from '@spartacus/core';

import { DpSiteContextComponent } from './components';
import { contextServiceMapProvider, measurementSystemInitializerProvider } from './providers';

import {
  DpChangeCountryEffect,
  DpGetLanguagesEffect,
  DpLoadCountriesEffect,
  DpLoadLanguagesEffect
} from './store/effects';
import * as measurementSystemsEffects from './store/effects/measurement-systems.effect';
import { siteContextReducers } from './store/site-context.reducers';
import { DP_SITE_CONTEXT_FEATURE } from './store/site-context.selectors';

@NgModule({
  imports: [
    MatIcon,
    AsyncPipe,
    I18nModule,
    StoreModule.forFeature(DP_SITE_CONTEXT_FEATURE, siteContextReducers),
    EffectsModule.forFeature(
      DpLoadCountriesEffect,
      DpLoadLanguagesEffect,
      DpGetLanguagesEffect,
      DpChangeCountryEffect,
      measurementSystemsEffects
    ),
    NgSelectModule,
    FormsModule,
    NgClass,
    BrowserAnimationsModule
  ],
  providers: [
    contextServiceMapProvider,
    measurementSystemInitializerProvider,
    provideConfig({ cmsComponents: { CMSSiteContextComponent: { component: DpSiteContextComponent } } }),
    provideConfig({
      state: { ssrTransfer: { keys: { [DP_SITE_CONTEXT_FEATURE]: StateTransferType.TRANSFER_STATE } } }
    })
  ],
  exports: [DpSiteContextComponent],
  declarations: [DpSiteContextComponent]
})
export class DpSiteContextModule {}
